module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_wales_text_02.eeb845bb.jpg";